export const INTERNATIONAL_UNITS = 0
export const ANGLO_SAXON_UNITS = 1
